import enCountries from '@/shared/i18n/en/countries.json';

type TranslateFn = (key: string, options?: { defaultValue?: string }) => string;

// AWS Location (Esri) returns ISO 3166-1 alpha-3 codes; map them to the country
// slug keys used by the `countries` i18n namespace (same keys as tenant.country).
export const ISO3_TO_COUNTRY_KEY: Record<string, string> = {
  AFG: 'afghanistan',
  ALB: 'albania',
  DZA: 'algeria',
  AND: 'andorra',
  AGO: 'angola',
  ATG: 'antigua_and_barbuda',
  ARG: 'argentina',
  ARM: 'armenia',
  AUS: 'australia',
  AUT: 'austria',
  AZE: 'azerbaijan',
  BHS: 'bahamas',
  BHR: 'bahrain',
  BGD: 'bangladesh',
  BRB: 'barbados',
  BLR: 'belarus',
  BEL: 'belgium',
  BLZ: 'belize',
  BEN: 'benin',
  BTN: 'bhutan',
  BOL: 'bolivia',
  BIH: 'bosnia_and_herzegovina',
  BWA: 'botswana',
  BRA: 'brazil',
  BRN: 'brunei',
  BGR: 'bulgaria',
  BFA: 'burkina_faso',
  BDI: 'burundi',
  CPV: 'cabo_verde',
  KHM: 'cambodia',
  CMR: 'cameroon',
  CAN: 'canada',
  CAF: 'central_african_republic',
  TCD: 'chad',
  CHL: 'chile',
  CHN: 'china',
  COL: 'colombia',
  COM: 'comoros',
  COD: 'congo_democratic_republic',
  COG: 'congo_republic',
  CRI: 'costa_rica',
  CIV: 'cote_divoire',
  HRV: 'croatia',
  CUB: 'cuba',
  CYP: 'cyprus',
  CZE: 'czech_republic',
  DNK: 'denmark',
  DJI: 'djibouti',
  DMA: 'dominica',
  DOM: 'dominican_republic',
  ECU: 'ecuador',
  EGY: 'egypt',
  SLV: 'el_salvador',
  GNQ: 'equatorial_guinea',
  ERI: 'eritrea',
  EST: 'estonia',
  SWZ: 'eswatini',
  ETH: 'ethiopia',
  FJI: 'fiji',
  FIN: 'finland',
  FRA: 'france',
  GAB: 'gabon',
  GMB: 'gambia',
  GEO: 'georgia',
  DEU: 'germany',
  GHA: 'ghana',
  GRC: 'greece',
  GRD: 'grenada',
  GTM: 'guatemala',
  GIN: 'guinea',
  GNB: 'guinea_bissau',
  GUY: 'guyana',
  HTI: 'haiti',
  HND: 'honduras',
  HUN: 'hungary',
  ISL: 'iceland',
  IND: 'india',
  IDN: 'indonesia',
  IRN: 'iran',
  IRQ: 'iraq',
  IRL: 'ireland',
  ISR: 'israel',
  ITA: 'italy',
  JAM: 'jamaica',
  JPN: 'japan',
  JOR: 'jordan',
  KAZ: 'kazakhstan',
  KEN: 'kenya',
  KIR: 'kiribati',
  PRK: 'korea_north',
  KOR: 'korea_south',
  XKX: 'kosovo',
  KWT: 'kuwait',
  KGZ: 'kyrgyzstan',
  LAO: 'laos',
  LVA: 'latvia',
  LBN: 'lebanon',
  LSO: 'lesotho',
  LBR: 'liberia',
  LBY: 'libya',
  LIE: 'liechtenstein',
  LTU: 'lithuania',
  LUX: 'luxembourg',
  MDG: 'madagascar',
  MWI: 'malawi',
  MYS: 'malaysia',
  MDV: 'maldives',
  MLI: 'mali',
  MLT: 'malta',
  MHL: 'marshall_islands',
  MRT: 'mauritania',
  MUS: 'mauritius',
  MEX: 'mexico',
  FSM: 'micronesia',
  MDA: 'moldova',
  MCO: 'monaco',
  MNG: 'mongolia',
  MNE: 'montenegro',
  MAR: 'morocco',
  MOZ: 'mozambique',
  MMR: 'myanmar',
  NAM: 'namibia',
  NRU: 'nauru',
  NPL: 'nepal',
  NLD: 'netherlands',
  NZL: 'new_zealand',
  NIC: 'nicaragua',
  NER: 'niger',
  NGA: 'nigeria',
  MKD: 'north_macedonia',
  NOR: 'norway',
  OMN: 'oman',
  PAK: 'pakistan',
  PLW: 'palau',
  PSE: 'palestine',
  PAN: 'panama',
  PNG: 'papua_new_guinea',
  PRY: 'paraguay',
  PER: 'peru',
  PHL: 'philippines',
  POL: 'poland',
  PRT: 'portugal',
  QAT: 'qatar',
  ROU: 'romania',
  RUS: 'russia',
  RWA: 'rwanda',
  KNA: 'saint_kitts_and_nevis',
  LCA: 'saint_lucia',
  VCT: 'saint_vincent_and_the_grenadines',
  WSM: 'samoa',
  SMR: 'san_marino',
  STP: 'sao_tome_and_principe',
  SAU: 'saudi_arabia',
  SEN: 'senegal',
  SRB: 'serbia',
  SYC: 'seychelles',
  SLE: 'sierra_leone',
  SGP: 'singapore',
  SVK: 'slovakia',
  SVN: 'slovenia',
  SLB: 'solomon_islands',
  SOM: 'somalia',
  ZAF: 'south_africa',
  SSD: 'south_sudan',
  ESP: 'spain',
  LKA: 'sri_lanka',
  SDN: 'sudan',
  SUR: 'suriname',
  SWE: 'sweden',
  CHE: 'switzerland',
  SYR: 'syria',
  TWN: 'taiwan',
  TJK: 'tajikistan',
  TZA: 'tanzania',
  THA: 'thailand',
  TLS: 'timor_leste',
  TGO: 'togo',
  TON: 'tonga',
  TTO: 'trinidad_and_tobago',
  TUN: 'tunisia',
  TUR: 'turkey',
  TKM: 'turkmenistan',
  TUV: 'tuvalu',
  UGA: 'uganda',
  UKR: 'ukraine',
  ARE: 'united_arab_emirates',
  GBR: 'united_kingdom',
  USA: 'united_states',
  URY: 'uruguay',
  UZB: 'uzbekistan',
  VUT: 'vanuatu',
  VAT: 'vatican_city',
  VEN: 'venezuela',
  VNM: 'vietnam',
  YEM: 'yemen',
  ZMB: 'zambia',
  ZWE: 'zimbabwe',
};

const normalize = (value: string) =>
  value
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

// Normalised English name / slug -> slug key. Built from the countries bundle so it
// matches regardless of case, accents or punctuation ("Côte d'Ivoire" -> cote_divoire),
// and also matches when the value is already a slug (they normalise identically).
const NORMALIZED_NAME_TO_KEY: Record<string, string> = {};
for (const [key, name] of Object.entries(
  enCountries as Record<string, string>,
)) {
  NORMALIZED_NAME_TO_KEY[normalize(name)] = key;
  NORMALIZED_NAME_TO_KEY[normalize(key)] = key;
}

// Common English names that differ from the bundle's canonical name.
const ENGLISH_ALIASES: Record<string, string> = {
  unitedstatesofamerica: 'united_states',
  russianfederation: 'russia',
  czechia: 'czech_republic',
  southkorea: 'korea_south',
  republicofkorea: 'korea_south',
  northkorea: 'korea_north',
  democraticpeoplesrepublicofkorea: 'korea_north',
  turkiye: 'turkey',
  ivorycoast: 'cote_divoire',
  capeverde: 'cabo_verde',
  swaziland: 'eswatini',
  macedonia: 'north_macedonia',
  republicofnorthmacedonia: 'north_macedonia',
  burma: 'myanmar',
  laopeoplesdemocraticrepublic: 'laos',
  syrianarabrepublic: 'syria',
  iranislamicrepublicof: 'iran',
  boliviaplurinationalstateof: 'bolivia',
  venezuelabolivarianrepublicof: 'venezuela',
  unitedrepublicoftanzania: 'tanzania',
  tanzaniaunitedrepublicof: 'tanzania',
  republicofmoldova: 'moldova',
  moldovarepublicof: 'moldova',
  bruneidarussalam: 'brunei',
  democraticrepublicofthecongo: 'congo_democratic_republic',
  congokinshasa: 'congo_democratic_republic',
  republicofthecongo: 'congo_republic',
  congobrazzaville: 'congo_republic',
  holysee: 'vatican_city',
  vaticancitystate: 'vatican_city',
  stateofpalestine: 'palestine',
  federatedstatesofmicronesia: 'micronesia',
  thegambia: 'gambia',
  thebahamas: 'bahamas',
};

// Normalises a country value (ISO alpha-3 from geocoding, a country slug, or an
// English name — including common variants — from the IP-derived flow) to the shared
// `countries` slug key used everywhere else (e.g. tenant.country). Returns the raw
// value if unmatched, so this is what we persist.
export const resolveCountryKey = (
  country: string | null | undefined,
): string | null => {
  if (!country) {
    return null;
  }
  const fromIso3 = ISO3_TO_COUNTRY_KEY[country.toUpperCase()];
  if (fromIso3) {
    return fromIso3;
  }
  const norm = normalize(country);
  return NORMALIZED_NAME_TO_KEY[norm] ?? ENGLISH_ALIASES[norm] ?? country;
};

// Translates a country value to a localized name via the `countries` namespace,
// falling back to the raw value when it can't be matched.
export const resolveCountryLabel = (
  country: string | null | undefined,
  t: TranslateFn,
): string | null => {
  const key = resolveCountryKey(country);
  if (!key) {
    return null;
  }
  return t(`countries:${key}`, { defaultValue: country ?? key });
};
